import { makeStyles } from "@material-ui/core/styles";
import DrawSVG from "react-svg-drawing";

const useStyles = makeStyles((theme) => ({
  logo: {
    display: "block",
    marginTop: theme.spacing(10),
    padding: 0,
  },
}));

function HeartLogo(props) {
  const classes = useStyles();
  return (
    <DrawSVG
      duration="4000"
      easing="easeInOutCubic"
      width="80%"
      strokeWidth="2.5"
      height="fit-content"
    >
      <svg viewBox="0 0 1870.9 907.1" className={classes.logo}>
        <path
          style={
            props.thick
              ? props.white
                ? { strokeWidth: 15, stroke: "white" }
                : { strokeWidth: 15 }
              : props.white
              ? { stroke: "white" }
              : {}
          }
          d="M930.7,835.8c0,0-29.6-28.8-40.2-38.6c-18.6-17.3-37.6-34.3-56.4-51.4c-11.5-10.4-23.1-20.7-34.5-31.1
		c-20.6-18.7-41.1-37.5-61.5-56.3c-7.2-6.6-14.3-13.2-21.3-20.1c-17.8-17.5-35.9-34.7-53.2-52.6c-33.5-34.6-65.6-70.4-93.2-110
		c-13.2-18.9-25.3-38.4-35.5-59.1c-12-24.1-21-49.3-26.6-75.7c-5-23.6-6.1-47.5-4.8-71.4c1-19,4.8-37.7,10.8-55.7
		c10.8-32.4,27.7-61.3,51.5-86.1c20.3-21.2,43.7-37.8,70.4-49.9c17.5-7.9,35.7-13.9,54.8-16.7c12.3-1.8,24.7-3.2,37.1-3.6
		c28.9-1,56.9,4.2,84.1,13.8c34.4,12.1,65.2,30.3,91.3,55.8c8.7,8.5,10.7,11.3,18.9,20.2c0.7,0.8,8.3,9.4,8.3,9.4s4.4-5,6.3-7.3
		c20.1-24.8,44.4-44.5,72.2-60c22.5-12.6,46.4-21.5,71.4-26.9c9.8-2.1,19.8-3,29.8-4c7.9-0.8,15.9-1,23.9-1
		c18.6,0.1,36.9,2.9,54.8,7.6c31.5,8.2,60.1,22.5,85.3,43.1c32.1,26.1,55.3,58.7,69.6,97.5c6.2,16.9,10.4,34.2,12.6,51.9
		c2.1,17.1,2.8,34.4,0.5,51.6c-1.7,12.9-3.6,25.8-6,38.7c-3,16.2-8.7,31.7-15,46.9c-14.3,35-34.4,66.6-56.9,96.8
		c-17.3,23.2-35.9,45.4-55.9,66.4c-21.2,22.2-42.3,44.6-64.2,66c-26.1,25.4-52.9,50.1-79.9,74.6
		C1050.9,724.5,958.9,809.8,930.7,835.8"
        />
        <path
          style={
            props.thick
              ? props.white
                ? { strokeWidth: 15, stroke: "white" }
                : { strokeWidth: 15 }
              : props.white
              ? { stroke: "white" }
              : {}
          }
          d="M23.9,446.9c5.7-0.3,574.3-0.3,580.5-0.3l-0.4-71.8l-1.1-2.9c0,0-0.5-12-0.3-14.1c0.2-2.9-0.4-5.4-2.2-7.7
		c-0.4-0.5-0.6-1.1-1.2-2.3c0.8-0.6,1.7-1.2,2.6-1.9c7.4-5.3,14-11.7,20.2-18.3c1.6-1.7,3.5-3.1,5.6-4.3c3.2-1.8,6-4.2,8.9-6.5
		c3.7-3,7.3-6.2,11.1-9.5c1.2,0.9,2.1,1.6,3.1,2.4c4.8,3.9,9.3,8.4,14.5,11.7c5.1,3.2,9.3,7.2,13.4,11.5c3.6,3.8,7.6,7.3,11.8,10.5
		c1.9,1.5,3.7,3,5.5,4.4c0,0.6,0.1,1-0.1,1.2c-3.2,3.8-2.8,13.3-2.8,13.3l-0.3,8.6l-0.9,2.8c0,0-0.1,3.7-0.1,4.5
		c-0.2,11.3-0.5,22.7-0.6,34c-0.1,9.8,0,19.5,0,29.3c0,1.6,0.1,3.1,0.1,4.8l3.4,0l0-5c0-18.4,0-36.8,0-55.2c0-6.1,0-12.2,0-18.2
		c0-1.6,0-3.2,0-4.8c10.1-12.2,20-24.2,30.2-36.6c0,0,14,20.6,19.9,29.5c0.9,1.3,1.8,2.5,3,4.1c8-9.2,15.3-18.4,23.3-27.7
		c8.4,10.5,16.4,20.6,24.3,30.5c0.2,27.9,0.4,56.1,0.5,83.6c0,0.1,9.4,0,9.4,0s0-51.2,0-75.4c0-0.6-0.1-1.3-0.2-2.1
		c-1.2-0.9-2.4-1.9-3.9-3.1c0.4-3.2,0.9-6.5,1.4-9.9c1.8-0.2,3.5-0.5,5.3-0.7l0.7-5c1.8-0.3,3.4-0.5,5.3-0.8
		c0.3-1.8,0.5-3.4,0.8-5.3c1.9-0.3,3.5-0.5,5.5-0.7c0.2-1.8,0.4-3.5,0.7-5.4c1.7-0.2,3.3-0.3,5.1-0.5c0.2-1.7,0.4-3.4,0.7-5.5
		c1.6-0.3,3.3-0.5,5.2-0.8c0.2-1.8,0.4-3.5,0.6-5.3l9.1-0.1c0.3,1.8,0.6,3.3,0.9,5.3c1.5,0.2,3,0.5,4.8,0.8c0.2,1.7,0.5,3.5,0.8,5.5
		c1.7,0.2,3.2,0.4,5,0.6c0.3,1.8,0.5,3.4,0.8,5.3c1.8,0.2,3.5,0.5,5.5,0.7c0.2,1.8,0.4,3.4,0.7,5.4l5.3,0c0,0,0-2.2,0-3.3
		c0-17.8,0.1-35.5,0-53.3c0-2-0.6-4.1-1.2-6.1c-0.6-2.3-1.5-4.5-2.4-7l5-0.2c0,0,0.2-9.1-1.4-13.4c1.8-1,3.4-2,5.3-3.1
		c1.4-4.2,4.6-7.3,8.2-10.2c0,0,0.7-7.8-0.8-8c1.7-2.2,2.7-3.8,4.5-5.8c3.3-3.7,6.9-3.5,10.1,0.5c1.4,1.7,2.6,3.6,3.7,5.3
		c-1.6,0.5-0.8,7.6-0.8,7.6c3.8,2.5,9.4,7.5,10.3,11.7l2.6,1.8c0.6,0.3,1,0.7,1.8,1.2c-2.3,3.8-2,12.7-2,12.7l5.5,0.2
		c0,0-0.7,3.5-1.4,5c-1.5,3.1-2,6.3-2,9.7c0.1,48.5,0,96.9,0.1,145.4c0,1.9-0.1,5.7-0.1,5.7l27.2-0.2c0.5-2.9,0.1-5.9,0.3-8.9
		c0.3-4.6-0.8-8.8-2.9-12.9c-1.7-3.4-2.6-6.9-2.6-10.9c0-14.2-0.3-28.4-0.7-42.6c-0.1-5.6-0.6-11.1-0.9-17.1c-1-0.6-2.2-1.3-3.4-2
		c0-0.5,0-0.9,0.1-1.4c0.1-0.5,0.4-0.9,0.6-1.3c2.6-5.2,2.6-5.4,7.5-7.8c3.4-1.7,6.7-3.7,9.7-6c8.2-6.1,16.4-12,23.3-19.6
		c0.3-0.3,0.8-0.6,1.5-1.1c17.5,1.6,35.3,3.3,53.3,4.9c1.3,3.9,2.5,7.7,3.8,11.7c5.9,1.5,12.1,0.6,18.2,2c4,4.5,8.2,9.1,12.6,14.1
		c-0.1,0.3-0.4,1.2-0.8,2.4c6.1,5.2,12.4,10.6,19,16.2c-1.1,1.2-2.1,2.2-3.2,3.3v7.9c5.2,3.3,11.2,5.4,17.1,9
		c-1.4,1.2-2.6,2.2-3.7,3.1v6.5c3.7,1.2,7.3,2.3,11.4,3.6c-1.6,1.6-2.9,2.9-4.1,4.1c-0.7,8.3,0,42.8,0,42.8l7.4,0.2
		c0,0,0.2-3.8,0.2-5.7c0-19.5,0-39,0-58.5c0-1.7,0-3.5,0-5.3c13.5-13.6,27-27,40.5-40.5v-16.6c13.8-17,27.6-33.9,41.6-51.2
		l10.9,12.9c1.7,2.1,3.4,4.2,5.1,6.3c1.7,2.1,3.4,4.2,5.1,6.3c1.7,2.1,3.4,4.2,5.1,6.3c1.8,2.2,3.6,4.5,5.4,6.7
		c1.7,2.1,3.4,4.2,5.1,6.3c1.7,2.1,3.4,4.2,5.2,6.5v19.4l8.2,5.2c0,0,0-3.7,0-5.2c0.1-13.6,0-27.2,0-40.8c0-1.8,0-3.5,0-4.9
		c1.8-2.4,5.3-6.4,5.3-6.4s-0.3,2.5,0,0c2.1-15,4.8-37.8,6.8-52.8c0.2-1.6,0.5-3.1,0.7-4.8l3.7,0c0,0,1.6,8.8,2.2,13.1l5.8,44.9l0,0
		l4.9,6.1v79.9c1,1.2,1.8,2.3,2.8,3.6c0,5.7,0,11.4,0,17.2c0,5.8,0,11.5,0,17.3c0,5.8-0.1,11.5,0,17.3c0.1,5.7,0.3,17.6,0.3,17.6
		l5.8,0.1c40.1,0,572.1-0.4,574.5,0.5"
        />
      </svg>
    </DrawSVG>
  );
}

export default HeartLogo;
